import { render, staticRenderFns } from "./EditPageDetailsSettings.vue?vue&type=template&id=3998240a&"
import script from "./EditPageDetailsSettings.vue?vue&type=script&lang=js&"
export * from "./EditPageDetailsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports